import { userConstants,CouponConstants, CategoryConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { userService, commonService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { apiConstants } from "../_constants/api.constants";

//import rootReducer from '../_reducers';
//import { createStore } from 'redux'

//const store = createStore(rootReducer)

export const categoryActions = {
    saveCategory, 
    getAllCategory,
    getAllSubCategory,
    getCategoryById,
    editCategory,
    getAllActiveCategory,
    deleteCategory
  
};

//-- Login function
function saveCategory(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(CategoryConstants.CATEGORY_ADDED_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      categoryData => {        
                        dispatch(commonAction.success(CategoryConstants.CATEGORY_ADDED_SUCCESS, categoryData));
                      },
      error => {
                  dispatch( commonAction.failure(CategoryConstants.CATEGORY_ADDED_FAILURE, error) );
                  // dispatch(alertActions.error(error.response.data.error));
               }
      );
  };
}

//get categories
function getAllCategory (apiName, catObj) {
    return dispatch => {
        dispatch(commonAction.request(CategoryConstants.CATEGORY_GET_REQUEST, catObj ));
        commonService.withTokenPut(apiName, catObj).then(
          categoryData => {        
                            dispatch(commonAction.success(CategoryConstants.CATEGORY_GET_SUCCESS, categoryData));
                          },
          error => {
                      dispatch( commonAction.failure(CategoryConstants.CATEGORY_GET_FAILURE, error) );
                   }
          );
      };
}

//get all sub categories
function getAllSubCategory (apiName, catObj) {
  return dispatch => {
      dispatch(commonAction.request(CategoryConstants.SUB_CATEGORY_GET_REQUEST, catObj ));
      commonService.withTokenPut(apiName, catObj).then(
        categoryData => {        
                          dispatch(commonAction.success(CategoryConstants.SUB_CATEGORY_GET_SUCCESS, categoryData));
                        },
        error => {
                    dispatch( commonAction.failure(CategoryConstants.SUB_CATEGORY_GET_FAILURE, error) );
                 }
        );
    };
}

function getCategoryById (apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(CategoryConstants.CATEGORY_BY_ID_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      categoryData => {        
                        dispatch(commonAction.success(CategoryConstants.CATEGORY_BY_ID_SUCCESS, categoryData));
                      },
      error => {
                  dispatch( commonAction.failure(CategoryConstants.CATEGORY_BY_ID_FAILURE, error) );                 
               }
      );
  };
}


function editCategory (apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(CategoryConstants.CATEGORY_EDIT_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      categoryData => {        
                        dispatch(commonAction.success(CategoryConstants.CATEGORY_EDIT_SUCCESS, categoryData));
                      },
      error => {
                  dispatch( commonAction.failure(CategoryConstants.CATEGORY_EDIT_FAILURE, error) );                 
               }
      );
  };
}

//get all the active categories
function getAllActiveCategory (apiName, catObj) {
  return dispatch => {
      dispatch(commonAction.request(CategoryConstants.CATEGORY_GET_ACTIVE_REQUEST, catObj ));
      commonService.withTokenPut(apiName, catObj).then(
        categoryData => {        
                          dispatch(commonAction.success(CategoryConstants.CATEGORY_GET_ACTIVE_SUCCESS, categoryData));
                        },
        error => {
                    dispatch( commonAction.failure(CategoryConstants.CATEGORY_GET_ACTIVE_FAILURE, error) );
                 }
        );
    };
}

//delete category
function deleteCategory(apiName, catObj) {
  return dispatch => {
      dispatch(commonAction.request(CategoryConstants.CATEGORY_DELETE_REQUEST, catObj ));
      commonService.withTokenPut(apiName, catObj).then(
        categoryData => {        
                          dispatch(commonAction.success(CategoryConstants.CATEGORY_DELETE_SUCCESS, categoryData));
                        },
        error => {
                    dispatch( commonAction.failure(CategoryConstants.CATEGORY_DELETE_FAILURE, error) );
                 }
        );
    };
}